import React, { useMemo } from 'react';
import * as THREE from 'three';
import { CELL_SIZE, NFT_SELECTION_COLOR } from '../constants';
import { useNFTContext } from '../context/NFTContext';
import { getWorldPositionFromNFT } from '../utils/floor_utils';

const SelectionHighlightBox = () => {
  const { selectedNFT } = useNFTContext();

  // if currently selected nft needs a highlight
  const selectedNFTHighlightInfo = useMemo<{
    position: THREE.Vector3;
    scale: THREE.Vector3;
    heightZ: number;
    widthX: number;
  }>(() => {
    if (
      selectedNFT &&
      selectedNFT.endX > -1 &&
      selectedNFT.startX > -1 &&
      selectedNFT.endY > -1 &&
      selectedNFT.startY > -1
    ) {
      const amountOfBoxesX = selectedNFT.endX - selectedNFT.startX + 1;
      const amountOfBoxesZ = selectedNFT.endY - selectedNFT.startY + 1;
      const worldPosition = getWorldPositionFromNFT(
        selectedNFT,
        CELL_SIZE,
        amountOfBoxesX,
        amountOfBoxesZ
      ) ?? {
        x: Number.MAX_SAFE_INTEGER,
        y: Number.MAX_SAFE_INTEGER,
        z: Number.MAX_SAFE_INTEGER,
      };

      return {
        position: new THREE.Vector3(worldPosition.x, 0.1, worldPosition.z),
        scale: new THREE.Vector3(amountOfBoxesZ, 0.98, amountOfBoxesX),
        widthX: amountOfBoxesX,
        heightZ: amountOfBoxesZ,
      };
    } else {
      return {
        position: new THREE.Vector3(
          Number.MAX_SAFE_INTEGER,
          Number.MAX_SAFE_INTEGER,
          Number.MAX_SAFE_INTEGER
        ),
        scale: new THREE.Vector3(1, 1, 1),
        widthX: 0,
        heightZ: 0,
      };
    }
  }, [selectedNFT]);

  if (selectedNFT) {
    return (
      <>
        {/* outter top line */}
        <mesh
          position={[
            selectedNFTHighlightInfo.position.x +
              (selectedNFTHighlightInfo?.heightZ * CELL_SIZE) / 2 -
              1.5,
            selectedNFTHighlightInfo.position.y + 0.27,
            selectedNFTHighlightInfo.position.z,
          ]}
          scale={
            new THREE.Vector3(
              0.1,
              selectedNFTHighlightInfo.scale.y,
              selectedNFTHighlightInfo.scale.z
            )
          }
        >
          <boxGeometry args={[CELL_SIZE * 0.99, CELL_SIZE, CELL_SIZE * 0.99]} />
          <meshStandardMaterial
            transparent={true}
            opacity={1}
            color={NFT_SELECTION_COLOR}
          />
        </mesh>
        {/* outter bottom line */}
        <mesh
          position={[
            selectedNFTHighlightInfo.position.x -
              (selectedNFTHighlightInfo?.heightZ * CELL_SIZE) / 2 +
              1.48,
            selectedNFTHighlightInfo.position.y + 0.27,
            selectedNFTHighlightInfo.position.z,
          ]}
          scale={
            new THREE.Vector3(
              0.1,
              selectedNFTHighlightInfo.scale.y,
              selectedNFTHighlightInfo.scale.z
            )
          }
        >
          <boxGeometry args={[CELL_SIZE * 0.99, CELL_SIZE, CELL_SIZE * 0.99]} />
          <meshStandardMaterial
            transparent={true}
            opacity={1}
            color={NFT_SELECTION_COLOR}
          />
        </mesh>
        {/* outter left line */}
        <mesh
          position={[
            selectedNFTHighlightInfo.position.x - 0.01,
            selectedNFTHighlightInfo.position.y + 0.27,
            selectedNFTHighlightInfo.position.z -
              (selectedNFTHighlightInfo?.widthX * CELL_SIZE) / 2 +
              1.5,
          ]}
          scale={
            new THREE.Vector3(
              selectedNFTHighlightInfo.scale.x,
              selectedNFTHighlightInfo.scale.y,
              0.1
            )
          }
        >
          <boxGeometry args={[CELL_SIZE * 0.99, CELL_SIZE, CELL_SIZE * 0.99]} />
          <meshStandardMaterial
            transparent={true}
            opacity={1}
            color={NFT_SELECTION_COLOR}
          />
        </mesh>
        {/* outter right line */}
        <mesh
          position={[
            selectedNFTHighlightInfo.position.x,
            selectedNFTHighlightInfo.position.y + 0.27,
            selectedNFTHighlightInfo.position.z +
              (selectedNFTHighlightInfo?.widthX * CELL_SIZE) / 2 -
              1.5,
          ]}
          scale={
            new THREE.Vector3(
              selectedNFTHighlightInfo.scale.x,
              selectedNFTHighlightInfo.scale.y,
              0.1
            )
          }
        >
          <boxGeometry args={[CELL_SIZE * 0.99, CELL_SIZE, CELL_SIZE * 0.99]} />
          <meshStandardMaterial
            transparent={true}
            opacity={1}
            color={NFT_SELECTION_COLOR}
          />
        </mesh>
      </>
    );
  }

  return null;
};

export default SelectionHighlightBox;
